<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 20h-1v-8.57l.31.3A1 1 0 0021 12a1 1 0 00.73-.31 1 1 0 000-1.42l-9-8.5a1 1 0 00-1.38 0l-9 8.5a1 1 0 101.38 1.46l.31-.3V20H3a1 1 0 000 2h18a1 1 0 000-2zm-10.5 0v-4h3v4zm5 0v-5a1 1 0 00-1-1h-5a1 1 0 00-1 1v5H6V9.54l6-5.66 6 5.66V20z"/></svg>